import React from "react";
import "./Tag.css";

/**
 * Tag - Reusable tag component for displaying product tags
 * @param {string} text - Tag text
 * @param {string} [size] - Tag size (xs, sm, md, lg)
 * @param {string} [variant] - Tag variant (primary, secondary, success, warning, error)
 * @param {string} [className] - Additional CSS classes
 */
const Tag = ({ text, size = "sm", variant = "secondary", className = "" }) => {
 return (
 <span className={`tag tag--${size} tag--${variant} ${className}`}>
 {text}
 </span>
 );
};

export default Tag;
